import { configureStore } from "@reduxjs/toolkit";
import { sessionReducer } from "redux-react-session";

export const store = configureStore({
    reducer: {
        session: sessionReducer
    }
});